export interface NoticeBlockProps {
    MessageTitle: string,
    MessageBody: string
}

export function NoticeBlock(props: NoticeBlockProps) {
    return <div className="MessageData_Container">
        <fieldset className="MessageData">
            <legend dangerouslySetInnerHTML={{ __html: props.MessageTitle }}></legend>
            <p dangerouslySetInnerHTML={{ __html: props.MessageBody }}></p>
        </fieldset>
    </div>
}